import {flipwitFirebaseConnector} from '../flipwitFirebaseConnector'
import { platformHandler } from '../PlatformHandler'

let osHandler = {};

/*module.exports = function ElectronHandler() {

  return osHandler;
}*/

osHandler.init = function(){
  
}

osHandler.signInWithEmailAndPassword = function(data) {
  return flipwitFirebaseConnector.signInWithEmailAndPassword(data);
}
osHandler.fetchSignInMethodsForEmail = function(data) {
  return flipwitFirebaseConnector.fetchSignInMethodsForEmail(data);
}

osHandler.signInGoogle = function() {
  var callbackOAuth = function(oauth) {
    flipwitFirebaseConnector.signInWithCredential( oauth );
  }

  const remote = window.require('electron').remote;
  //const remote = require('electron').remote;
  remote.app.createGoogleOauthWindow(callbackOAuth);
}

osHandler.executeCommand = function( command ){
  platformHandler.FlipwitSlideConnector.executeCommand( command ); 
}

osHandler.insertActivity = function( id, urlImg, pptName, comment, webView ){
  platformHandler.FlipwitSlideConnector.insertActivity( id, urlImg, pptName, comment, webView );
}

osHandler.getPptsOpen = function( ){
  platformHandler.FlipwitSlideConnector.getPptsOpen();
}

osHandler.toggleFullScreen = function( value ){
  const remote = window.require('electron').remote;
  remote.app.toggleFullScreen();
}

osHandler.toggleDevTools = function(  ){
  const remote = window.require('electron').remote;
  remote.app.toggleDevTools();
}

osHandler.openExternalURL = (url) => {
  const shell = window.require('electron').shell;
  shell.openExternal(url)
}

export default function ElectronHandler() {
  console.log('Si pasa por acá')
  return osHandler;
}


// WEBPACK FOOTER //
// ./src/containers/platforms/electron/ElectronHandler.js